import ExtentUtils from "@/utils/ExtentUtils";

export default [
    {
        path: '/facilities',
        name: 'buildings',
        component: () => import(/* webpackChunkName: "facilities" */ '@/components/AppModuleNavigator.vue'),
        props: {parentRouteName: 'buildings'},
        meta: {
            title: 'BUILDINGS',
            icon: 'mdi-table-search'
        },
        children: [
            {
                path: 'buildings',
                name: 'facilities-buildings',
                component: () => import(/* webpackChunkName: "facilities" */ '../pages/Facilities.vue'),
                meta: {
                    title: 'BUILDINGS',
                    gtm: 'buildings-list',
                    icon: 'mdi-table-search'
                }
            },
            {
                path: 'building-additions',
                name: 'facilities-additions',
                props: route => ({query: route.query.q}),
                component: () => import(/* webpackChunkName: "facilities" */ '../pages/FacilityAdditions.vue'),
                meta: {
                    title: 'BUILDING ADDITIONS',
                    gtm: 'buildings-additions-list',
                    icon: 'mdi-table-search'
                }
            },
            {
                path: 'building-complexes',
                name: 'facilities-complexes',
                props: route => ({query: route.query.q}),
                component: () => import(/* webpackChunkName: "facilities" */ '../pages/FacilityComplexes.vue'),
                meta: {
                    title: 'BUILDING COMPLEXES',
                    gtm: 'buildings-complexes-list',
                    icon: 'mdi-table-search'
                }
            },
            {
                path: '/facilities',
                name: 'facilities-default',
                redirect: '/facilities/buildings',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    },
    {
        path: '/facilities/buildings/:facilityId',
        name: 'facilities-facility-detail',
        props: true,
        component: () => import(/* webpackChunkName: "facilityDetail" */ '../components/FacilityDetail'),
        meta: {
            title: 'BUILDING DETAIL',
            gtm: 'buildings-detail',
            icon: 'mdi-table-search',
            displayInNavigation: false
        },
        children: [
            {
                path: 'details',
                name: 'facilities-facility-detail-detail',
                component: () => import(/* webpackChunkName: "facilityDetail" */ '../components/FacilityDetailsDetail.vue'),
                props: true,
                meta: {
                    pageTitle: 'Building Detail',
                    gtm: 'building-detail'
                }
            },
            {
                path: 'additions',
                name: 'facilities-facility-detail-additions',
                component: () => import(/* webpackChunkName: "facilityDetail" */ '../components/FacilityAdditions'),
                props: true,
                meta: {
                    pageTitle: 'Building Detail (Additions)',
                    gtm: 'buildings-detail-additions',
                }
            },
            {
                path: 'addresses',
                name: 'facilities-facility-detail-addresses',
                component: () => import(/* webpackChunkName: "facilityDetail" */ '../components/FacilityAddresses'),
                props: true,
                meta: {
                    pageTitle: 'Building Detail (Addresses)',
                    gtm: 'buildings-detail-addresses',
                }
            },
            {
                path: 'projects',
                name: 'facilities-facility-detail-projects',
                component: () => import(/* webpackChunkName: "shared" */ '../components/FacilityProjects'),
                props: true,
                meta: {
                    pageTitle: 'Building Detail (Projects)',
                    gtm: 'buildings-detail-projects',
                }
            },
            {
                path: 'documents',
                name: 'facilities-facility-detail-documents',
                component: () => import(/* webpackChunkName: "shared" */ '../components/FacilityLinksDocuments.vue'),
                props: true,
                meta: {
                    pageTitle: 'Building Detail (Documents)',
                    gtm: 'buildings-detail-documents',
                }
            },
            {
                path: 'map',
                name: 'facilities-facility-detail-map',
                component: () => import(/* webpackChunkName: "maps" */ '@/modules/maps/pages/WepMap.vue'),
                props: route => ({
                    facilityId: route.params.facilityId,
                    mobileExternalUrl: `https://fieldmaps.arcgis.app?portalURL=https://gis.msu.edu/portal&itemID=c988e84faf794d1ebbed66fd8f26dc87&referenceContext=search&search=${route.params.facilityId}`
                }),
                meta: {
                    pageTitle: 'Building Detail (Map)',
                    gtm: 'buildings-detail-map',
                },
                beforeEnter: async (to, from, next) => {
                    const result = await ExtentUtils.getFacilityExtent(to.params.facilityId)

                    if (result?.extent) next()
                    else next({path: `/facilities/buildings/${to.params.facilityId}/details`})
                }
            },
            {
                path: '/facilities/buildings/:facilityId',
                redirect: '/facilities/buildings/:facilityId/details',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    },
    {
        path: '/facilities/building-complexes/:complexId',
        name: 'facility-complex-detail',
        props: true,
        component: () => import(/* webpackChunkName: "facilities" */ '../components/FacilityComplexDetail'),
        meta: {
            title: 'BUILDING COMPLEX DETAIL',
            icon: 'mdi-table-search',
            displayInNavigation: false
        },
        children: [
            {
                path: '/facilities/building-complexes/:complexId/buildings',
                name: 'complex-detail-buildings',
                component: () => import(/* webpackChunkName: "facilities" */ '../components/FacilityComplexBuildings.vue'),
                props: true,
                meta: {
                    pageTitle: 'Building Complex (Buildings)',
                    gtm: 'building-complex-buildings',
                }
            },
            {
                path: '/facilities/building-complexes/:complexId/projects',
                name: 'complex-detail-projects',
                component: () => import(/* webpackChunkName: "facilities" */ '../components/FacilityProjects'),
                props: route => ({facilityId: route.params.complexId}),
                meta: {
                    pageTitle: 'Building Complex (Projects)',
                    gtm: 'building-complex-projects',
                }
            },
            {
                path: '/facilities/building-complexes/:complexId/campus-map',
                name: 'building-detail-campus-map',
                component: () => import(/* webpackChunkName: "maps" */ '@/modules/maps/pages/WepMap.vue'),
                props: route => ({
                    complexId: route.params.complexId,
                    webMapId: '967e167e8a9f46cbb8b8cbd39654ab44'
                }),
                meta: {
                    pageTitle: 'Building Complex (Campus Map)',
                    gtm: 'building-complex-map-campus',
                }
            },
            {
                path: '/facilities/building-complexes/:complexId/infrastructure-map',
                name: 'building-detail-infrastructure-map',
                component: () => import(/* webpackChunkName: "maps" */ '@/modules/maps/pages/WepMap.vue'),
                props: route => ({
                    complexId: route.params.complexId,
                    webMapId: 'abd744c13cd64458ae169ed72577b32f'
                }),
                meta: {
                    pageTitle: 'Building Complex (Infrastructure Map)',
                    gtm: 'building-complex-map-infrastructure',
                }
            },
            {
                path: '/facilities/building-complexes/:complexId/assets-map',
                name: 'building-detail-assets-map',
                component: () => import(/* webpackChunkName: "maps" */ '@/modules/maps/pages/WepMap.vue'),
                props: route => ({
                    complexId: route.params.complexId,
                    webMapId: '5c2f7c0f5bab4066bab2c7cab49511cb'
                }),
                meta: {
                    pageTitle: 'Building Complex (Assets Map)',
                    gtm: 'building-complex-map-assets',
                }
            },
            {
                path: '/facilities/building-complexes/:complexId',
                name: 'facilities-complex-default',
                redirect: '/facilities/building-complexes/:complexId/buildings',
                meta: {
                    title: 'redirect'
                }
            }
        ]
    }
]
